import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

const useStyles = makeStyles(theme => ({
  highlight: {
    backgroundColor: theme.palette.action.hover
  }
}));

function HighlightedTitle(props) {
  const classes = useStyles();

  function getHighlightedTitle() {
    if (props.searchInput) {
      let titleArray = props.title.split(
        new RegExp(`(${props.searchInput.toLowerCase()})`, "gi")
      );
      return titleArray.map((titleSection, index) => {
        if (titleSection.toLowerCase() === props.searchInput.toLowerCase()) {
          return (
            <Typography component="span" key={index}>
              <mark className={classes.highlight}>{titleSection}</mark>
            </Typography>
          );
        } else {
          return (
            <Typography component="span" key={index}>
              {titleSection}
            </Typography>
          );
        }
      });
    } else {
      return <Typography component="span">{props.title}</Typography>;
    }
  }

  return getHighlightedTitle();
}

export default HighlightedTitle;

HighlightedTitle.propTypes = {
  title: PropTypes.string,
  searchInput: PropTypes.string
};
